import { c as _taggedTemplateLiteralLoose, d as _extends } from './chunk-eb25cfa0.js';
import { ifProp, theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import { createElement } from 'react';
import { oneOf } from 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import '@emotion/is-prop-valid';
import 'react-dom';
import { a as hoist } from './chunk-0cd02bff.js';
import './chunk-11bd1c20.js';
import './Hidden.js';
import 'constate';
import './chunk-061cef7c.js';
import './chunk-22b2fb47.js';
import Overlay from './Overlay.js';
import { a as OverlayContainer, b as OverlayToggle, c as OverlayShow, d as OverlayHide } from './chunk-73fe7b59.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  top: 0;\n  height: 100vh;\n  transform: none;\n  overflow: auto;\n  left: ", ";\n  right: ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SidebarComponent = function SidebarComponent(props) {
  return createElement(Overlay, _extends({
    defaultSlide: props.align === "right" ? "left" : "right"
  }, props));
};

var Sidebar = styled(hoist(SidebarComponent, Overlay))(_templateObject(), ifProp({
  align: "right"
}, "auto", 0), ifProp({
  align: "right"
}, 0, "auto"), theme("Sidebar")); // @ts-ignore

Sidebar.propTypes = {
  align: oneOf(["left", "right"])
};
Sidebar.defaultProps = {
  align: "left",
  translateX: 0,
  translateY: 0
};
var Sidebar$1 = use(Sidebar, "div");
var SidebarContainer = OverlayContainer;

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var SidebarToggle = styled(OverlayToggle)(_templateObject$1(), theme("SidebarToggle"));
var SidebarToggle$1 = use(SidebarToggle, "button");

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var SidebarShow = styled(OverlayShow)(_templateObject$2(), theme("SidebarShow"));
var SidebarShow$1 = use(SidebarShow, "button");

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var SidebarHide = styled(OverlayHide)(_templateObject$3(), theme("SidebarHide"));
var SidebarHide$1 = use(SidebarHide, "button");
var index = Object.assign(Sidebar$1, {
  Container: SidebarContainer,
  Toggle: SidebarToggle$1,
  Show: SidebarShow$1,
  Hide: SidebarHide$1
});
export default index;